import React, { useState, useEffect } from "react";
import MultiSelect from "../ui/MultiSelect";
import {
  Option,
  MultiValue,
  ValueContainer,
  ValueContainerDisplayResult,
} from "./corporate/reports/MultiValueComponents";
import { isSuperAgent } from "../modules/permissions";
import {
  isGroupAdmin,
  isGroupUser,
  isVenue,
  token,
  userId,
  venues,
} from "../modules/auth";
import { connect } from "react-redux";
import {
  fetchHotelGroups,
  fetchVenuesForGivenGroupsAndBrands,
} from "../services/hotelGroupService/hotelGroupFilterService";
import { brand } from "../styles/colors";
import { components } from "react-select";
import { LiveSearchSimple } from "./Form/LiveSearch/LiveSearchSimple";

let HotelGroupFilters = ({
  token,
  change,
  hasPassedVenues,
  passedVenues = [],
  personalVenues = [],
  selectedHotelGroups,
  selectedHotelBrands,
  selectedVenues,
  setSelectedHotelGroups,
  setSelectedHotelBrands,
  setSelectedVenues,
  isVenueUser,
  country,
  setCountry
}) => {
  const [hotelGroups, setHotelGroups] = useState([]);
  const [hotelBrands, setHotelBrands] = useState([]);
  const [venues, setVenues] = useState([]);
  const [groups, setGroups] = useState([]);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (isVenueUser) {
      fetchHotelGroups(token).then(response => {
        if (response && typeof response.data !== "undefined") {
          setGroups(response.data);
          setHotelGroups(
            response.data.filter(group => group.parentGroup === null)
          );
          setHotelBrands(
            response.data.filter(group => group.parentGroup !== null)
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    let groupIds = [];
    if (!selectedHotelGroups || selectedHotelGroups.length < 1) {
      setHotelBrands([]);
      setVenues([]);
      // setSelectedHotelGroups([]);
      // setSelectedVenues([]);
    }
    if (selectedHotelBrands && selectedHotelBrands.length > 0) {
      selectedHotelBrands.forEach(group => {
        groupIds.push(group.value);
      });
      fetchVenuesForGivenGroupsAndBrands(groupIds,null, token).then(response => {
        setVenues(response);
      });
    } else {
      if (selectedHotelGroups && selectedHotelGroups.length > 0) {
        selectedHotelGroups.forEach(group => {
          groupIds.push(group.value);
        });
        fetchVenuesForGivenGroupsAndBrands(groupIds,null, token).then(response => {
          if (
            selectedHotelGroups.filter(groups => groups.value === "").length !==
              0 &&
            personalVenues &&
            personalVenues.length > 0 &&
            personalVenues !== "*"
          ) {
            setVenues(personalVenues.flat());

            //setSelectedVenues(selectedVenues)
          } else {
            setVenues(response);
          }
        });
      }
    }
  }, [selectedHotelGroups, selectedHotelBrands]);

  useEffect(() => {
    if (!selectedHotelGroups || selectedHotelGroups.length === 0) {
      if (hotelGroups.length === 1 && passedVenues.length === 0) {
        const defaultGroup = getHotelGroupOptions().find(
          group => group.value === hotelGroups[0].id
        );
        if (
          !selectedHotelGroups ||
          selectedHotelGroups.length === 0 ||
          selectedHotelGroups[0]?.value !== defaultGroup?.value
        ) {
          handleHotelGroupSelect(defaultGroup, true);
        }
      } else if (
        hotelGroups.length > 1 ||
        (hotelGroups.length === 1 && passedVenues.length !== 0) ||
        (hotelGroups.length === 0 && passedVenues.length !== 0)
      ) {
        const noGroup = getHotelGroupOptions().find(
          group => group.value === ""
        );
        if (
          !selectedHotelGroups ||
          selectedHotelGroups.length === 0 ||
          selectedHotelGroups[0]?.value !== noGroup?.value
        ) {
          handleHotelGroupSelect(noGroup, true);
        }
      }
    } else {
      const current = getHotelGroupOptions().find(
        group => group.value === selectedHotelGroups[0].value
      );
      if (current && selectedHotelGroups[0]?.value !== current.value) {
        handleHotelGroupSelect(current, true);
      }
    }
  }, [hotelGroups]);

  const getHotelGroupOptions = () => {
    let options = [];
    options.push({
      text: "No Groups",
      value: "",
      label: "No Groups",
      parent: null,
      childVenues: null,
    });
    if (hotelGroups && Object.keys(hotelGroups).length > 0) {
      let groups = [];
      Object.values(hotelGroups).forEach(group => {
        groups = groups.concat(group);
      });
      groups
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
            parent: group.parentGroup,
          });
        });
    }
    return options;
  };

  const getHotelBrandOptions = () => {
    let options = [];
    if (hotelBrands && Object.keys(hotelBrands).length > 0) {
      let brands = [];
      Object.values(hotelBrands).forEach(brand => {
        brands = brands.concat(brand);
      });
      brands
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(brand => {
          options.push({
            text: brand.name,
            value: brand.id,
            label: brand.name,
            parent: brand.parentGroup,
          });
        });
    }
    return options;
  };
  const getVenueOptions = () => {
    let options = [];

    if (venues && Object.keys(venues).length > 0) {
      let vs = [];
      Object.values(venues).forEach(venue => {
        vs = vs.concat(venue);
      });
      vs.sort((a, b) => a.name.localeCompare(b.name)).map(venue => {
        options.push({
          text: venue.name,
          value: venue.id,
          label: venue.name,
        });
      });
    }

    return options;
  };

  const handleHotelBrandSelect = e => {
    let params = [];
    if (e) {
      e.map(brand => {
        params.push(brand);
      });
    }
    setSelectedHotelBrands(params);
    setSelectedVenues([]);
  };

  const handleHotelGroupSelect = selected => {
    let params = [];
    let childrenFromSearch = false;
    if (selected) {
      if (!Array.isArray(selected)) {
        params.push(selected);
      } else {
        selected.map(group => {
          params.push(group);
          if (group.children) {
            setHotelBrands(group.children);
            childrenFromSearch = true;
          }
        });
      }
    }
    if (selected && selected.length === 0) {
      if (!childrenFromSearch) {
        setHotelBrands(groups.filter(group => group.parentGroup !== null));
      }
    } else {
      setSelectedHotelGroups(params);
      if (!childrenFromSearch) {
        setHotelBrands(
          groups.filter(
            brand =>
              brand.parentGroup &&
              params.map(param => param.value).includes(brand.parentGroup.id)
          )
        );
      }
    }

    setSelectedVenues([]);

    setSelectedHotelBrands([]);
  };

  const handleVenueSelect = e => {
    let params = [];
    if (e && e.length > 0) {
      e.map(venue => {
        params.push(venue);
      });
    }

    setSelectedVenues(params);
  };

  return (
    <div className={"flex my-3 w-full"}>
      <div className={"mr-5"}>
        <div className="w-full lg:w-48">
          {isVenueUser ? (
            <MultiSelect
              isClearable={true}
              name="hotel_group"
              label="Filter by Hotel Group"
              options={getHotelGroupOptions()}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              wrapperClassName="mb-0"
              onChange={e => handleHotelGroupSelect(e)}
              value={selectedHotelGroups}
              autoComplete={"off"}
              style={{
                searchBox: {
                  "border-radius": "0px",
                },
              }}
              components={{
                ValueContainer: ValueContainerDisplayResult,
              }}
            />
          ) : (
            <LiveSearchSimple
              fieldClassName="mb-2 xxl:mb-0 mr-2 w-full lg:w-48"
              name="hotel_group"
              label="Filter By Hotel Group"
              labelClassName="block uppercase font-heading mb-1 text-xs "
              auth
              multiSelect={true}
              url={`${window.API}/search/hotel-groups?parentGroup=1`}
              onChange={e => {
                handleHotelGroupSelect([
                  {
                    text: e.name,
                    value: e.id,
                    label: e.name,
                    parent: e.parentGroup,
                    children: e.children,
                  },
                ]);
              }}
              onClear={e => {
                setSelectedHotelGroups([]);
                setSelectedHotelBrands([]);
                setSelectedVenues([]);
              }}
            />
          )}
        </div>
      </div>
      <div className={"w-full lg:w-48 mr-5"} style={{flexGrow: '1'}}>
        <MultiSelect
          name="hotel_brand"
          label="Filter by Hotel Brand"
          isMulti
          isDisabled={getHotelBrandOptions().length < 1}
          options={getHotelBrandOptions()}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          wrapperClassName="mb-0"
          onChange={e => handleHotelBrandSelect(e)}
          autoComplete={"off"}

          value={selectedHotelBrands}
          style={{
            searchBox: {
              "border-radius": "0px",
            },
          }}
        />
      </div>
      <div className={"w-full lg:w-48  mr-5"}  style={{ flexGrow: "1" }}>
        <MultiSelect
          name="venues"
          isMulti
          label="Filter by Venue"
          isDisabled={getVenueOptions().length < 1}
          options={getVenueOptions()}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          wrapperClassName="mb-0"
          onChange={e => handleVenueSelect(e)}
          autoComplete={"off"}
          value={selectedVenues}
          style={{
            searchBox: {
              "border-radius": "0px",
            },
          }}
        />
      </div>
      {/*<div className={"w-full lg:w-48"}>*/}
      {/*  <LiveSearchSimple*/}
      {/*    fieldClassName="mb-0"*/}
      {/*    name="country"*/}
      {/*    label="Filter By Country"*/}
      {/*    labelClassName="block uppercase font-heading mb-1 text-xs"*/}
      {/*    auth*/}
      {/*    url={`${window.API}/search/countries`}*/}
      {/*    onChange={country => setCountry(country.id)}*/}
      {/*    onClear={() => setCountry("")}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  );
};
export default connect((state, ownProps) => ({
  token: token(state),
  isVenueUser: isVenue(state) || isGroupUser(state) || isGroupAdmin(state),
  isGroupUser: isGroupUser(state),
  hasPassedVenues: typeof ownProps.personalVenues !== "undefined",
  passedVenues:
    typeof ownProps.personalVenues !== "undefined" &&
    ownProps.personalVenues.length > 0
      ? ownProps.personalVenues
      : venues(state),
  personalVenues: venues(state),
}))(HotelGroupFilters);
